var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasetteBetamax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 352C177.625 352 192 337.625 192 320S177.625 288 160 288S128 302.375 128 320S142.375 352 160 352ZM528 32H48C21.49 32 0 53.49 0 80V128H576V80C576 53.49 554.51 32 528 32ZM0 432C0 458.51 21.49 480 48 480H528C554.51 480 576 458.51 576 432V160H0V432ZM320 224H512V416H320V224ZM160 224C212.951 224 256 267.051 256 320S212.951 416 160 416C107.051 416 64 372.949 64 320S107.051 224 160 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasetteBetamax);
export default __webpack_public_path__ + "static/media/casette-betamax.d8493ed65fde06be62c36126a90e9ef4.svg";
export { ForwardRef as ReactComponent };